module.exports = __webpack_public_path__ + "dfd82a67d2824ce70bb543aa29e5a0a2.png";